import { ITermCourse, ICrossCourseCorequisite } from '../../interfaces/scheduler_interfaces';
import { SectionRequisites } from '../../views/course_scheduler/types/requisite_enum';
import { TermCourseServant } from '../../views/term_courses/servants/term_course_servant';
import * as _4 from 'lodash4';
import { ScheduledSectionsQuery } from '../../views/course_scheduler/queries/scheduled_sections_query';

class SectionCorequisiteController {
  private coreqCourses: ICrossCourseCorequisite[];
  private course: ITermCourse;
  private hasCoreqs: boolean = false;
  private hideControls: boolean = false;

  constructor(
    private ngTermCourseServant: TermCourseServant,
    private ngScheduledSectionsQuery: ScheduledSectionsQuery
  ) {}
  $onChanges() {
    this.init();
  }
  init() {
    this.hasCoreqs = !_4.isEmpty(this.coreqCourses);
    this.hideControls = !this.ngTermCourseServant.isCourseScheduled(this.course);
  }
  $onInit() {
    this.init();
  }
  isCoReqCoursePlanned(coreqCourse: any) {
    return coreqCourse.status === 'SATISFIED';
  }
  getButtonType(coreq: ICrossCourseCorequisite) {
    const sectionLength = _4.get(coreq, 'length');
    const sectionCount = _4.get(coreq, 'section_count', sectionLength);
    return sectionCount === 1 ? SectionRequisites.ONE_TO_ONE : SectionRequisites.ONE_TO_MANY;
  }
  getCoreqStatus(coreq: ICrossCourseCorequisite) {
    const coreqStatus = _4.get(
      _4.find(_4.get(this.ngScheduledSectionsQuery, 'result.list', []), { course: coreq.id }),
      'status',
      false
    );
    return coreqStatus || coreq.status;
  }
}

angular.module('capability-ng-scheduler').component('sectionCorequisite', {
  templateUrl: 'capability-ng-scheduler/src/components/section_corequisite/section_corequisite.html',
  bindings: {
    coreqCourses: '<',
    course: '<'
  },
  controller: SectionCorequisiteController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_corequisite/section_corequisite.ts